module.exports = __webpack_public_path__ + "static/media/hitbtc.6a99bcdb.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/exchanges/hitbtc.png
// module id = 103
// module chunks = 0